(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const faqItems = document.querySelectorAll('.faq-item');
        faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');
            const answer = item.querySelector('.faq-answer');
            question.addEventListener('click', function() {
                faqItems.forEach(i => {
                    if (i !== item) {
                    i.classList.remove('active');
                    }
                });
                item.classList.toggle('active');
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }
  });

  document.addEventListener("shopify:section:load", () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mochypop-account"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.mp-acc');
    if (!root) return;

    var tabs = root.querySelectorAll('[data-mp-acc-tabs] .mp-acc__tab');
    var search = root.querySelector('[data-mp-acc-search]');
    var orders = root.querySelectorAll('.mp-acc__order');
    var noResults = root.querySelector('[data-mp-acc-noresults]');
    var activeFilter = 'all';
    var query = '';

    function apply() {
      var visible = 0;
      orders.forEach(function (card) {
        var okStatus = activeFilter === 'all' || card.dataset.status === activeFilter;
        var okSearch = !query || (card.dataset.search || '').indexOf(query) !== -1;
        var show = okStatus && okSearch;
        card.hidden = !show;
        if (show) visible++;
      });
      if (noResults) noResults.hidden = visible !== 0 || orders.length === 0;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-pressed', 'true');
        activeFilter = tab.dataset.filter;
        apply();
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        query = search.value.trim().toLowerCase();
        apply();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mochypop-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mp-cart]');
    if (!root) return;

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1]);
    }

    var errorEl = root.querySelector('[data-mp-cart-error]');
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || "Something went wrong updating your cart. Please try again.";
      errorEl.hidden = false;
      window.clearTimeout(showError._t);
      showError._t = window.setTimeout(function () { errorEl.hidden = true; }, 5000);
    }

    function updateFromCart(cart) {
      // Header count pill
      var pill = root.querySelector('[data-mp-cart-count-pill]');
      if (pill) pill.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

      // Totals
      var sub = root.querySelector('[data-mp-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);
      var tot = root.querySelector('[data-mp-cart-total]');
      if (tot) tot.textContent = formatMoney(cart.total_price);

      // Shipping progress
      if (threshold > 0) {
        var fill = root.querySelector('[data-mp-cart-ship-fill]');
        var msg = root.querySelector('[data-mp-cart-ship-msg]');
        var pct = Math.min(100, Math.round((cart.items_subtotal_price / threshold) * 100));
        if (fill) fill.style.width = pct + '%';
        if (msg) {
          if (cart.items_subtotal_price >= threshold) {
            msg.innerHTML = "You've unlocked free shipping! 🎉";
          } else {
            msg.innerHTML = "You're <strong>" + formatMoney(threshold - cart.items_subtotal_price) + "</strong> away from free shipping.";
          }
        }
      }

      // Line rows: totals / bubbles, remove rows gone from cart
      var keys = {};
      cart.items.forEach(function (it) { keys[it.key] = it; });
      root.querySelectorAll('[data-mp-cart-line]').forEach(function (row) {
        var key = row.getAttribute('data-key');
        var it = keys[key];
        if (!it) {
          row.classList.add('is-removing');
          window.setTimeout(function () { row.remove(); }, 280);
          return;
        }
        row.classList.remove('is-busy');
        var input = row.querySelector('[data-mp-cart-qty-input]');
        if (input) input.value = it.quantity;
        var bubble = row.querySelector('[data-mp-cart-line-bubble]');
        if (bubble) bubble.textContent = it.quantity;
        var lineTotal = row.querySelector('[data-mp-cart-line-total]');
        if (lineTotal) lineTotal.textContent = formatMoney(it.final_line_price);
        var unit = row.querySelector('[data-mp-cart-line-unit]');
        if (unit) unit.textContent = formatMoney(it.final_price);
      });

      // Empty cart -> reload to show the dedicated empty state.
      if (cart.item_count === 0) window.location.reload();

      document.dispatchEvent(new CustomEvent('mp:cart:updated', { detail: cart }));
    }

    var pending = false;
    function changeLine(row, qty) {
      if (pending) return;
      pending = true;
      row.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: row.getAttribute('data-key'), quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
        .then(updateFromCart)
        .catch(function () { row.classList.remove('is-busy'); showError(); })
        .finally(function () { pending = false; });
    }

    // Quantity +/- and manual input
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mp-cart-qty]');
      if (btn) {
        var row = btn.closest('[data-mp-cart-line]');
        var input = row.querySelector('[data-mp-cart-qty-input]');
        var qty = parseInt(input.value, 10) || 0;
        qty += btn.getAttribute('data-mp-cart-qty') === 'inc' ? 1 : -1;
        if (qty < 0) qty = 0;
        changeLine(row, qty);
        return;
      }
      var rm = e.target.closest('[data-mp-cart-remove]');
      if (rm) {
        e.preventDefault();
        changeLine(rm.closest('[data-mp-cart-line]'), 0);
      }
    });
    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-mp-cart-qty-input]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      changeLine(input.closest('[data-mp-cart-line]'), qty);
    });

    // Quick add
    root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-mp-cart-quick-add]');
      if (!add) return;
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(add.getAttribute('data-mp-cart-quick-add'), 10), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'add failed'); });
          return r.json();
        })
        .then(function () {
          add.classList.add('is-added');
          // Reload so the new line renders with full Liquid markup.
          window.setTimeout(function () { window.location.reload(); }, 450);
        })
        .catch(function (err) {
          add.disabled = false;
          showError(err && err.message ? err.message : null);
        });
    });

    // Recommendations nav
    var recs = root.querySelector('[data-mp-cart-recs]');
    if (recs) {
      root.querySelectorAll('[data-mp-cart-recs-nav]').forEach(function (nav) {
        nav.addEventListener('click', function () {
          var first = recs.querySelector('[data-mp-cart-rec]');
          var step = first ? first.offsetWidth + 14 : 160;
          recs.scrollBy({ left: nav.getAttribute('data-mp-cart-recs-nav') === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mochypop-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mp-coll]');
    if (!root) return;

    // Auto-submit filters on checkbox change (price stays manual via Apply).
    var form = root.querySelector('[data-mp-coll-filters]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-mp-coll-auto]')) form.submit();
      });
    }

    // Auto-apply sort while keeping active filter params.
    var sortSel = root.querySelector('[data-mp-coll-auto-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Wishlist visual toggle.
    root.addEventListener('click', function (e) {
      var w = e.target.closest('[data-mp-coll-wish]');
      if (w) w.classList.toggle('is-liked');
    });

    // Ajax quick-add for single-variant products; native submit fallback.
    root.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-mp-coll-atc]');
      if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]');
      var id = parseInt(f.querySelector('input[name="id"]').value, 10);
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'error'); });
          return r.json();
        })
        .then(function () {
          if (btn) {
            btn.classList.add('is-added');
            var label = btn.querySelector('span');
            if (label) label.textContent = 'Added ✓';
            window.setTimeout(function () {
              btn.classList.remove('is-added');
              if (label) label.textContent = 'Add to cart';
              btn.disabled = false;
            }, 1800);
          }
          document.dispatchEvent(new CustomEvent('mp:cart:updated'));
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          f.submit();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mochypop-home-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.mp-bs');
    sections.forEach(section => {
      const car = section.querySelector('[data-mp-bs-carousel]');
      if (!car) return;

      const cards = car.querySelectorAll('[data-mp-bs-card]');
      const prev = section.querySelector('[data-mp-bs-nav="prev"]');
      const next = section.querySelector('[data-mp-bs-nav="next"]');

      function stepSize() {
        const first = car.querySelector('[data-mp-bs-card]');
        if (!first) return 240;
        const style = getComputedStyle(car);
        const gap = parseInt(style.columnGap || style.gap || 20, 10) || 20;
        return first.offsetWidth + gap;
      }

      if (prev) prev.addEventListener('click', () => car.scrollBy({ left: -stepSize(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => car.scrollBy({ left:  stepSize(), behavior: 'smooth' }));

      function updateNav() {
        if (!prev || !next) return;
        const max = car.scrollWidth - car.clientWidth - 2;
        prev.disabled = car.scrollLeft <= 2;
        next.disabled = car.scrollLeft >= max;
      }
      car.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();

      // Pagination dots
      const dotsHost = section.querySelector('[data-mp-bs-dots]');
      if (dotsHost && cards.length > 0) {
        dotsHost.innerHTML = '';
        cards.forEach((_, i) => {
          const d = document.createElement('span');
          d.className = 'mp-bs__dot' + (i === 0 ? ' is-active' : '');
          dotsHost.appendChild(d);
        });
        const dots = dotsHost.querySelectorAll('.mp-bs__dot');
        const io = new IntersectionObserver(entries => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              const idx = Array.prototype.indexOf.call(cards, e.target);
              dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
            }
          });
        }, { root: car, threshold: 0.6 });
        cards.forEach(c => io.observe(c));
      }

      // Wishlist toggle — visual only; hook up to a real wishlist later.
      section.querySelectorAll('[data-mp-bs-wish]').forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          const on = btn.getAttribute('data-liked') === 'true';
          btn.setAttribute('data-liked', on ? 'false' : 'true');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mochypop-home-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.mp-rv').forEach(section => {
      const car = section.querySelector('[data-mp-rv-carousel]');
      if (!car) return;
      const cards = car.querySelectorAll('[data-mp-rv-card]');
      const prev = section.querySelector('[data-mp-rv-nav="prev"]');
      const next = section.querySelector('[data-mp-rv-nav="next"]');

      function step() {
        const first = car.querySelector('[data-mp-rv-card]');
        if (!first) return 260;
        const gap = parseInt(getComputedStyle(car).columnGap || getComputedStyle(car).gap || 20, 10) || 20;
        return first.offsetWidth + gap;
      }

      if (prev) prev.addEventListener('click', () => car.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => car.scrollBy({ left:  step(), behavior: 'smooth' }));

      function updateNav() {
        if (!prev || !next) return;
        const max = car.scrollWidth - car.clientWidth - 2;
        prev.disabled = car.scrollLeft <= 2;
        next.disabled = car.scrollLeft >= max;
      }
      car.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();

      const dotsHost = section.querySelector('[data-mp-rv-dots]');
      if (dotsHost && cards.length > 0) {
        dotsHost.innerHTML = '';
        cards.forEach((_, i) => {
          const d = document.createElement('span');
          d.className = 'mp-rv__dot' + (i === 0 ? ' is-active' : '');
          dotsHost.appendChild(d);
        });
        const dots = dotsHost.querySelectorAll('.mp-rv__dot');
        const io = new IntersectionObserver(entries => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              const idx = Array.prototype.indexOf.call(cards, e.target);
              dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
            }
          });
        }, { root: car, threshold: 0.6 });
        cards.forEach(c => io.observe(c));
      }

      section.querySelectorAll('[data-mp-rv-wish]').forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          const on = btn.getAttribute('data-liked') === 'true';
          btn.setAttribute('data-liked', on ? 'false' : 'true');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mochypop-pdp-story"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.mp-pp').forEach(section => {
      const rvCar = section.querySelector('[data-mp-pp-rv]');
      const rvNext = section.querySelector('[data-mp-pp-rv-next]');
      if (rvCar && rvNext) {
        rvNext.addEventListener('click', () => {
          const first = rvCar.querySelector('[data-mp-pp-rv-card]');
          const gap = parseInt(getComputedStyle(rvCar).columnGap || getComputedStyle(rvCar).gap || 14, 10) || 14;
          const step = first ? first.offsetWidth + gap : 260;
          const atEnd = rvCar.scrollLeft + rvCar.clientWidth >= rvCar.scrollWidth - 4;
          rvCar.scrollTo({ left: atEnd ? 0 : rvCar.scrollLeft + step, behavior: 'smooth' });
        });
      }

      const relCar = section.querySelector('[data-mp-pp-rel]');
      const relNext = section.querySelector('[data-mp-pp-rel-next]');
      if (relCar && relNext) {
        relNext.addEventListener('click', () => {
          const first = relCar.querySelector('[data-mp-pp-rel-card]');
          const gap = parseInt(getComputedStyle(relCar).columnGap || getComputedStyle(relCar).gap || 14, 10) || 14;
          const step = first ? first.offsetWidth + gap : 180;
          const atEnd = relCar.scrollLeft + relCar.clientWidth >= relCar.scrollWidth - 4;
          relCar.scrollTo({ left: atEnd ? 0 : relCar.scrollLeft + step, behavior: 'smooth' });
        });
      }

      section.querySelectorAll('[data-mp-pp-rel-wish]').forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          const on = btn.getAttribute('data-liked') === 'true';
          btn.setAttribute('data-liked', on ? 'false' : 'true');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mochypop-pdp-storytelling"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.mp-pp3').forEach(section => {
      // Reviews carousel
      const rvCar = section.querySelector('[data-mp-pp3-rv-car]');
      const rvPrev = section.querySelector('[data-mp-pp3-rv="prev"]');
      const rvNext = section.querySelector('[data-mp-pp3-rv="next"]');
      if (rvCar) {
        function rvStep() {
          const first = rvCar.querySelector('[data-mp-pp3-rv-card]');
          if (!first) return 240;
          const gap = parseInt(getComputedStyle(rvCar).columnGap || getComputedStyle(rvCar).gap || 14, 10) || 14;
          return first.offsetWidth + gap;
        }
        if (rvPrev) rvPrev.addEventListener('click', () => rvCar.scrollBy({ left: -rvStep(), behavior: 'smooth' }));
        if (rvNext) rvNext.addEventListener('click', () => rvCar.scrollBy({ left:  rvStep(), behavior: 'smooth' }));
        function rvNav() {
          if (!rvPrev || !rvNext) return;
          const max = rvCar.scrollWidth - rvCar.clientWidth - 2;
          rvPrev.disabled = rvCar.scrollLeft <= 2;
          rvNext.disabled = rvCar.scrollLeft >= max;
        }
        rvCar.addEventListener('scroll', rvNav, { passive: true });
        window.addEventListener('resize', rvNav);
        rvNav();
      }

      // Sticky ATC bar — show when the main product form is out of view above
      const sticky = section.querySelector('[data-mp-pp3-sticky]');
      if (sticky) {
        const mainFormCandidates = [
          document.querySelector('.PDP__main-wrapper .product-form__submit'),
          document.querySelector('.pdp__main .product-form__submit'),
          document.querySelector('main .product-form__submit'),
          document.querySelector('.product-form__submit')
        ].filter(Boolean);
        const target = mainFormCandidates[0];

        function updateSticky() {
          if (!target) {
            sticky.setAttribute('data-visible', 'true');
            return;
          }
          const rect = target.getBoundingClientRect();
          // Show when the main ATC has scrolled fully above the viewport.
          if (rect.bottom < 20) {
            sticky.setAttribute('data-visible', 'true');
          } else {
            sticky.setAttribute('data-visible', 'false');
          }
        }
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
        updateSticky();

        // Qty stepper
        const qtyInput = sticky.querySelector('[data-mp-pp3-qty-input]');
        const qtyHidden = sticky.querySelector('[data-mp-pp3-qty-hidden]');
        function syncQty() {
          if (qtyInput && qtyHidden) qtyHidden.value = qtyInput.value;
        }
        sticky.querySelectorAll('[data-mp-pp3-qty]').forEach(btn => {
          btn.addEventListener('click', () => {
            if (!qtyInput) return;
            let n = parseInt(qtyInput.value, 10) || 1;
            n += btn.getAttribute('data-mp-pp3-qty') === 'inc' ? 1 : -1;
            if (n < 1) n = 1;
            qtyInput.value = n;
            syncQty();
          });
        });
        if (qtyInput) qtyInput.addEventListener('input', syncQty);
        syncQty();

        // Wishlist toggle
        const wish = sticky.querySelector('[data-mp-pp3-sticky-wish]');
        if (wish) {
          wish.addEventListener('click', () => {
            const on = wish.getAttribute('data-liked') === 'true';
            wish.setAttribute('data-liked', on ? 'false' : 'true');
          });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mochypop-track-order"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ParcelPanel sometimes enters its "tracked" state without rendering
    // any result block (order not found / not shipped / app hiccup),
    // leaving customers staring at empty space. Show our fallback note
    // whenever that happens; hide it the moment a real result renders.
    var app = document.getElementById('pp-tracking-page-app');
    var fallback = document.querySelector('[data-mp-track-fallback]');
    if (!app || !fallback) return;

    var trackedSince = 0;
    var GRACE_MS = 4000;

    function resultHeight() {
      var res = app.querySelector('.pp_tracking_result, [class*="tracking_result"], [class*="tracking-result"]');
      return res ? res.getBoundingClientRect().height : 0;
    }

    // Dropshipping privacy net: whatever class names the app uses,
    // hide any rendered "…Tracking Number" label + value block in the
    // RESULT area (never the lookup form's own tab/field).
    function hideTrackingNumbers() {
      var nodes = app.querySelectorAll('div, p, span, dt, h3, h4, strong, label');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.children.length > 1) continue;
        var t = (el.textContent || '').trim();
        if (!t || t.length > 40) continue;
        if (/^(last[\s_-]?mile\s+)?tracking\s+(number|no\.?)$/i.test(t)) {
          if (el.closest('.pp_tracking_form_div')) continue;
          var block = el.parentElement || el;
          if (block.style.display !== 'none') block.style.display = 'none';
        }
      }
    }

    function check() {
      var root = app.firstElementChild;
      var tracked = root && /is-tracked/.test(root.className);
      var h = resultHeight();
      if (tracked && h < 40) {
        if (!trackedSince) trackedSince = Date.now();
        if (Date.now() - trackedSince > GRACE_MS) fallback.hidden = false;
      } else {
        trackedSince = 0;
        fallback.hidden = true;
      }
      hideTrackingNumbers();
    }

    var timer = setInterval(check, 1000);
    new MutationObserver(check).observe(app, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    setTimeout(function () { clearInterval(timer); timer = setInterval(check, 3000); }, 30000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }

    function isInViewport(elem) {
      const rect = elem.getBoundingClientRect();
      return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    const stickyBar = document.querySelector('.PDP__stk__mainwrapper');
    const header = document.querySelector('.section-header');
    const headerHeight = header ? header.clientHeight : 0;
    const addToCartElements = document.querySelectorAll('[js-scroll-identity]');
    const footerSections = document.querySelectorAll('.shopify-section-group-footer-group');

    function shouldHideSticky() {
      for (const el of [...addToCartElements, ...footerSections]) {
        if (el && isInViewport(el)) return true;
      }
      return false;
    }

    function handleStickyScroll() {
      const scrollY = window.scrollY;
      const triggerElement = document.querySelector('[js-scroll-identity]');
      if (!triggerElement || !stickyBar) return;
      const triggerOffset = triggerElement.offsetTop;
      if (scrollY > triggerOffset) {
        if (shouldHideSticky()) {
          stickyBar.classList.remove('active');
        } else {
          stickyBar.classList.add('active');
        }
      } else {
        stickyBar.classList.remove('active');
      }
    }
    window.addEventListener('scroll', handleStickyScroll, { passive: true });

    /*
     * Sticky ATC → real ATC click forwarder.
     *
     * The sticky bar's submit button is rendered OUTSIDE the
     * <product-form> element, so a native click does nothing. We
     * intercept it and trigger a click on the real form's submit
     * button instead.
     *
     * Hardening vs. the previous version:
     *  C2 — every querySelector now null-checks. Either the sticky
     *       wrapper or the real form may be absent on certain PDPs
     *       (e.g. when the merchant disables the sticky bar via
     *       enable_sticky_info, or on a custom product template).
     *       The previous code crashed DOMContentLoaded with
     *       "Cannot read properties of null".
     *  H1 — single source of forwarding. The bundle snippet
     *       (sevicho-pdp-bundle-upsell.liquid) used to attach its own
     *       sticky forwarder too; that has been removed in favor of
     *       this one so the ATC can never double-fire.
     *  Defense-in-depth: a `data-sv-sticky-forwarded` marker prevents
     *       a second listener from being attached if any other script
     *       runs this initializer twice.
     */
    var stickyForwardSrc = document.querySelector('.PDP__stk__actionbtn .product-form__submit, .PDP__stk__mainwrapper .product-form__submit');
    var stickyForwardDst = document.querySelector('.product-form__buttons .product-form__submit, product-form button[type="submit"][name="add"]');
    if (
      stickyForwardSrc &&
      stickyForwardDst &&
      stickyForwardSrc !== stickyForwardDst &&
      !stickyForwardSrc.hasAttribute('data-sv-sticky-forwarded')
    ) {
      stickyForwardSrc.setAttribute('data-sv-sticky-forwarded', '1');
      stickyForwardSrc.addEventListener('click', function (ev) {
        // Re-entry guard: if the bundle snippet's submit listener has
        // already processed this event (different code path with the
        // same intent), skip. Cheap and safe.
        if (ev.__svPackForwarded) return;
        ev.__svPackForwarded = true;
        ev.preventDefault();
        stickyForwardDst.click();
      });
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-bundle-fixed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Sticky mobile bar: show only when the main CTA is offscreen (scrolled past),
    // hide when the main CTA is back in view. Wires the sticky button to the
    // main form so a single submit path stays in charge.
    document.querySelectorAll('[data-sv-bundle-fixed]').forEach(function (root) {
      var mainCta = root.querySelector('.sv-bundlefx__cta');
      var sticky = root.querySelector('[data-sv-bfx-sticky]');
      var stickyBtn = root.querySelector('[data-sv-bfx-sticky-trigger]');
      if (!mainCta || !sticky) return;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sticky.classList.remove('is-visible');
              sticky.setAttribute('aria-hidden', 'true');
            } else {
              sticky.classList.add('is-visible');
              sticky.setAttribute('aria-hidden', 'false');
            }
          });
        }, { rootMargin: '-100px 0px 0px 0px', threshold: 0 });
        io.observe(mainCta);
      }

      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (mainCta.disabled) return;
          mainCta.click();
          // Scroll the main card into view briefly so the shopper sees the
          // success animation on the primary CTA, not just the sticky bar.
          mainCta.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });

    document.querySelectorAll('[data-sv-bundle-fixed-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submit = form.querySelector('[data-sv-bundle-fixed-submit]');
        var label = form.querySelector('[data-sv-bundle-fixed-label]');
        var originalLabel = label ? label.innerHTML : '';
        if (submit) submit.disabled = true;
        if (label) label.innerHTML = 'Adding&hellip;';

        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' }
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            if (submit) submit.classList.add('is-added');
            if (label) label.innerHTML = '✓ Bundle added to cart';
            var root = form.closest('[data-sv-bundle-fixed]');
            var img = root ? root.querySelector('.sv-bundlefx__media-img') : null;
            var qty = fd.get('quantity');
            document.dispatchEvent(new CustomEvent('sevicho:cart:added', {
              detail: {
                variantId: fd.get('id'),
                quantity: qty ? parseInt(qty, 10) : 1,
                source: img,
                bundle: true
              }
            }));
            // Auto-open the cart drawer so the shopper sees the bundle land,
            // the progress bar move, and the next CTA. Wait for the
            // fly-to-cart animation to play first (700 ms).
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent('sevicho:cart:open'));
            }, 720);
            setTimeout(function () {
              if (submit) { submit.classList.remove('is-added'); submit.disabled = false; }
              if (label) label.innerHTML = originalLabel;
            }, 1400);
          })
          .catch(function () {
            if (label) label.innerHTML = 'Try again';
            if (submit) submit.disabled = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__sevichoCartPageInit) return;
    window.__sevichoCartPageInit = true;

    function getSection() {
      return document.querySelector('[data-cart-section]');
    }

    function getForm() {
      return document.querySelector('[data-cart-form]');
    }

    async function updateLine(key, qty) {
      const section = getSection();
      const cartChangeUrl = (section && section.dataset.cartChangeUrl) || ((window.routes && window.routes.cart_change_url) || '/cart/change');
      const res = await fetch(cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!res.ok) throw new Error('change failed');
      return res.json();
    }

    function replaceCartSection(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-section]');
      const current = getSection();
      if (fresh && current) {
        current.replaceWith(fresh);
      }
    }

    async function reloadCart() {
      const res = await fetch(window.location.pathname + window.location.search, { headers: { Accept: 'text/html' } });
      const html = await res.text();
      replaceCartSection(html);
    }

    let inputTimer = null;
    let pendingInputUpdate = null;

    async function applyLineUpdate(key, qty, fallbackForm) {
      try {
        await updateLine(key, qty);
        document.dispatchEvent(new CustomEvent('sevicho:cart:updated'));
        await reloadCart();
      } catch (err) {
        if (fallbackForm) fallbackForm.submit();
      }
    }

    document.addEventListener('click', async (e) => {
      const section = getSection();
      if (!section || !section.contains(e.target)) return;

      const dec = e.target.closest('[data-qty-dec]');
      const inc = e.target.closest('[data-qty-inc]');
      const remove = e.target.closest('[data-remove]');
      if (!dec && !inc && !remove) return;

      clearTimeout(inputTimer);
      pendingInputUpdate = null;

      const key = (dec || inc || remove).dataset.key;
      const input = section.querySelector('[data-qty-input][data-key="' + key + '"]');
      let qty = parseInt(input ? input.value : '1', 10) || 1;

      if (dec) qty = Math.max(0, qty - 1);
      if (inc) qty = qty + 1;
      if (remove) qty = 0;

      await applyLineUpdate(key, qty, getForm());
    });

    document.addEventListener('input', (e) => {
      const section = getSection();
      if (!section || !section.contains(e.target)) return;
      if (!e.target.matches('[data-qty-input]')) return;

      clearTimeout(inputTimer);
      pendingInputUpdate = {
        key: e.target.dataset.key,
        qty: Math.max(0, parseInt(e.target.value, 10) || 0),
      };

      inputTimer = setTimeout(async () => {
        const nextUpdate = pendingInputUpdate;
        pendingInputUpdate = null;
        if (!nextUpdate) return;
        await applyLineUpdate(nextUpdate.key, nextUpdate.qty, getForm());
      }, 600);
    });

    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-cart-form]');
      if (!form) return;
      const submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout' || !pendingInputUpdate) return;

      e.preventDefault();
      clearTimeout(inputTimer);
      const nextUpdate = pendingInputUpdate;
      pendingInputUpdate = null;

      try {
        await updateLine(nextUpdate.key, nextUpdate.qty);
        document.dispatchEvent(new CustomEvent('sevicho:cart:updated'));
      } catch (err) {
        // Fall back to native submit even if async update fails.
      }

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter);
      } else {
        submitter.click();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // 1. Sort dropdown: auto-submit when the merchant changes the sort option
    document.querySelectorAll('[data-sort-form] select').forEach((select) => {
      select.addEventListener('change', () => {
        const form = select.closest('form');
        if (form) form.submit();
      });
    });

    // 2. Filter form: auto-submit on any checkbox/radio change so shoppers get
    //    instant filtering (no dependency on a visible Apply button).
    //    Price range number inputs are debounced so a quick min+max edit only
    //    fires one submit.
    const filterForm = document.querySelector('[data-filter-form]');
    if (filterForm) {
      filterForm.addEventListener('change', (evt) => {
        const t = evt.target;
        if (!(t instanceof HTMLInputElement)) return;
        if (t.type === 'checkbox' || t.type === 'radio') {
          filterForm.submit();
        }
      });

      let priceTimer = null;
      filterForm.querySelectorAll('input[type="number"]').forEach((input) => {
        input.addEventListener('change', () => {
          clearTimeout(priceTimer);
          priceTimer = setTimeout(() => filterForm.submit(), 400);
        });
      });
    }

    // 3. Mobile filter drawer: the 'Filters' button toggles a slide-in panel
    const toggle = document.querySelector('[data-filter-toggle]');
    const filters = document.querySelector('[data-filters]');
    if (toggle && filters) {
      toggle.addEventListener('click', () => {
        const open = filters.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        document.body.style.overflow =
          open && window.innerWidth <= 900 ? 'hidden' : '';
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && filters.classList.contains('is-open')) {
          filters.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        }
      });
    }

    // 4. Active-filter count badge on the mobile toggle button
    const countEl = document.querySelector('[data-filter-count]');
    if (countEl) {
      const params = new URLSearchParams(window.location.search);
      let c = 0;
      params.forEach((_, k) => {
        if (k.startsWith('filter.')) c++;
      });
      if (c > 0) countEl.textContent = c;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-home-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-sv-announcement]');
    if (!bar) return;
    const msgs = bar.querySelectorAll('[data-sv-ann-msg]');
    if (msgs.length === 0) return;
    const prev = bar.querySelector('[data-sv-ann-prev]');
    const next = bar.querySelector('[data-sv-ann-next]');
    let i = 0;
    const interval = parseInt(bar.dataset.rotationMs || '0', 10) || 0;

    function go(n) {
      if (n < 0) n = msgs.length - 1;
      if (n >= msgs.length) n = 0;
      i = n;
      msgs.forEach((m, idx) => {
        m.classList.toggle('is-active', idx === n);
        if (idx === n) m.removeAttribute('aria-hidden'); else m.setAttribute('aria-hidden', 'true');
      });
    }
    msgs[0].classList.add('is-active');
    if (prev) prev.addEventListener('click', () => go(i - 1));
    if (next) next.addEventListener('click', () => go(i + 1));
    if (msgs.length > 1 && interval > 0) {
      let timer = setInterval(() => go(i + 1), interval);
      bar.addEventListener('mouseenter', () => clearInterval(timer));
      bar.addEventListener('mouseleave', () => { timer = setInterval(() => go(i + 1), interval); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-home-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const burger = document.querySelector('[data-sv-burger]');
    const drawer = document.querySelector('.sv-hdr__drawer[data-sv-drawer]');
    if (!burger || !drawer) return;
    // The header's backdrop-filter makes it the containing block for
    // position:fixed descendants, trapping the drawer inside the ~66px
    // sticky bar (only Search/Account peeked out). Reparent the drawer
    // to <body> so fixed positioning works against the viewport again.
    document.body.appendChild(drawer);
    function open() {
      drawer.hidden = false;
      void drawer.offsetHeight; // force reflow so the slide-in transition runs
      drawer.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function shut() {
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 300);
    }
    // Delegated, idempotent wiring: survives DOM patching and never
    // double-binds. Burger toggles; close button / backdrop / Escape shut.
    if (!window.__svHeaderNavWired) {
      window.__svHeaderNavWired = true;
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-sv-burger]')) {
          if (drawer.classList.contains('is-open')) shut(); else open();
          return;
        }
        if (e.target.closest('[data-sv-drawer-close]')) { shut(); return; }
        if (e.target === drawer) shut();
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) shut(); });
    }

    // Keep cart count hidden when 0
    document.addEventListener('sevicho:cart:added', () => {
      document.querySelectorAll('[data-sevicho-cart-count],[data-cart-count]').forEach(el => {
        if (el.textContent && parseInt(el.textContent, 10) > 0) el.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-popup]');
    if (!root) return;

    const STORAGE_KEY = 'sevicho:popup:last';
    const CAPTURED_KEY = 'sevicho:popup:captured';
    const delay = (parseInt(root.dataset.popupDelay, 10) || 8) * 1000;
    const frequencyDays = parseInt(root.dataset.popupFrequency, 10) || 7;
    const code = root.dataset.popupCode || '';

    function hasCaptured() {
      try { return localStorage.getItem(CAPTURED_KEY) === '1'; } catch { return false; }
    }
    function withinFrequency() {
      try {
        const last = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
        if (!last) return false;
        const daysSince = (Date.now() - last) / (1000 * 60 * 60 * 24);
        return daysSince < frequencyDays;
      } catch { return false; }
    }

    let lastFocus;
    function openPopup() {
      lastFocus = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      const dialog = root.querySelector('[role="dialog"]');
      dialog.focus();
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
    }
    function closePopup(mark) {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      if (mark !== false) {
        try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch {}
      }
    }

    function onKey(e) {
      if (e.key === 'Escape') closePopup();
      if (e.key === 'Tab') {
        const focusables = root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const visible = Array.from(focusables).filter((el) => !el.hasAttribute('hidden') && el.offsetParent !== null);
        if (!visible.length) return;
        const first = visible[0];
        const last = visible[visible.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    }

    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-popup-close]')) closePopup();
    });

    // Form submit → show success + mark captured
    const form = root.querySelector('[data-popup-form]');
    const startState = root.querySelector('[data-popup-state-start]');
    const successState = root.querySelector('[data-popup-state-success]');
    if (form && startState && successState) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(form);
        try {
          await fetch(form.action, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        } catch {}
        startState.hidden = true;
        successState.hidden = false;
        try { localStorage.setItem(CAPTURED_KEY, '1'); } catch {}
      });
    }

    // Copy code
    const copyBtn = root.querySelector('[data-popup-copy]');
    const copyLabel = root.querySelector('[data-popup-copy-label]');
    if (copyBtn && code) {
      copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(code);
        } catch {
          const range = document.createRange();
          range.selectNode(root.querySelector('[data-popup-code-display]'));
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
        }
        copyBtn.classList.add('is-copied');
        if (copyLabel) copyLabel.textContent = '✓ COPIED';
        setTimeout(() => {
          copyBtn.classList.remove('is-copied');
          if (copyLabel) copyLabel.textContent = 'COPY CODE';
        }, 2000);
      });
    }

    // Schedule
    if (hasCaptured() || withinFrequency()) return;
    setTimeout(openPopup, delay);

    // Exit-intent (desktop, pointer leaves viewport top)
    if (window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseleave', function onLeave(e) {
        if (e.clientY <= 0 && !hasCaptured() && !withinFrequency() && root.hidden) {
          openPopup();
          document.removeEventListener('mouseleave', onLeave);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-product-fbt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const fbt = document.querySelector('[data-sv-fbt]');
    if (!fbt) return;
    if (!fbt.querySelector('.sv-fbt__inner')) {
      const url = fbt.dataset.url;
      if (url) {
        fetch(url).then(r => r.text()).then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-sv-fbt]');
          if (fresh) fbt.innerHTML = fresh.innerHTML;
          init();
        }).catch(() => {});
      }
      return;
    }
    init();

    function init() {
      const root = document.querySelector('[data-sv-fbt]');
      if (!root) return;
      const form = root.querySelector('[data-sv-fbt-form]');
      if (!form) return;
      const currency = root.dataset.currencyCode || 'CAD';
      const currentVariantId = parseInt(root.dataset.currentVariantId || '0', 10);
      const cartAddUrl = form.getAttribute('action') || ((window.routes && window.routes.cart_add_url) || '/cart/add');
      function money(cents) { return (cents/100).toLocaleString(undefined, { style:'currency', currency }); }

      function recalc() {
        const inputs = form.querySelectorAll('[data-sv-fbt-item], [data-sv-fbt-current]');
        let total = 0;
        let count = 0;
        inputs.forEach(input => {
          const priceEl = input.closest('.sv-fbt__slot').querySelector('[data-sv-fbt-price]');
          const price = parseInt((priceEl && priceEl.getAttribute('data-sv-fbt-price')) || '0', 10);
          if (input.checked) { total += price; count += 1; priceEl?.classList.remove('is-off'); }
          else priceEl?.classList.add('is-off');
        });
        const totalEl = form.querySelector('[data-sv-fbt-total]');
        const countEl = form.querySelector('[data-sv-fbt-count]');
        if (totalEl) totalEl.textContent = money(total);
        if (countEl) countEl.textContent = count;
      }
      form.addEventListener('change', recalc);
      recalc();

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[data-sv-fbt-submit]');
        const originalLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        try {
          const items = [{ id: currentVariantId, quantity: 1 }];
          form.querySelectorAll('[data-sv-fbt-item]:checked').forEach(i => items.push({ id: i.value, quantity: 1 }));
          const res = await fetch(cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!res.ok) throw new Error('fail');
          btn.classList.add('is-added');
          btn.textContent = 'Added to cart';
          document.dispatchEvent(new CustomEvent('sevicho:cart:added'));
          setTimeout(() => { btn.classList.remove('is-added'); btn.textContent = originalLabel; btn.disabled = false; }, 2000);
        } catch { form.submit(); }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Async load recommendations if section is empty on first render
    document.querySelectorAll('[data-recommendations]').forEach((section) => {
      if (section.querySelector('.sevicho-recs__grid')) return;
      const url = section.dataset.url;
      if (!url) return;
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-recommendations]');
          if (fresh) section.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;

    const form = section.querySelector('[data-product-form]');
    const galleryEl = section.querySelector('[data-gallery]');
    const variantsScript = section.querySelector('[data-variants]');
    const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    const currencyCode = section.dataset.currencyCode || 'CAD';

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currencyCode });
    }

    const mains = galleryEl ? galleryEl.querySelectorAll('[data-main-slide]') : [];
    const thumbs = section.querySelectorAll('[data-thumb]');
    const prev = galleryEl ? galleryEl.querySelector('[data-gallery-prev]') : null;
    const next = galleryEl ? galleryEl.querySelector('[data-gallery-next]') : null;
    const counter = galleryEl ? galleryEl.querySelector('[data-counter]') : null;
    let currentIndex = 0;

    function show(idx) {
      if (mains.length === 0) return;
      if (idx < 0) idx = mains.length - 1;
      if (idx >= mains.length) idx = 0;
      currentIndex = idx;
      mains.forEach((el, i) => {
        el.classList.toggle('is-active', i === idx);
        el.setAttribute('tabindex', i === idx ? '0' : '-1');
        if (i === idx) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', 'true');
      });
      thumbs.forEach((el, i) => el.classList.toggle('is-active', i === idx));
      if (counter) counter.textContent = (idx + 1) + ' / ' + mains.length;
    }

    thumbs.forEach((thumb, idx) => thumb.addEventListener('click', () => show(idx)));
    if (prev) prev.addEventListener('click', () => show(currentIndex - 1));
    if (next) next.addEventListener('click', () => show(currentIndex + 1));
    if (galleryEl) {
      galleryEl.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { show(currentIndex + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(currentIndex - 1); e.preventDefault(); }
      });
      let sx = 0, sy = 0;
      galleryEl.addEventListener('touchstart', (e) => {
        if (!e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      galleryEl.addEventListener('touchend', (e) => {
        if (!e.changedTouches[0]) return;
        const dx = e.changedTouches[0].clientX - sx;
        const dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? currentIndex + 1 : currentIndex - 1);
      }, { passive: true });
    }

    // Zoom
    const zoomDialog = section.querySelector('[data-zoom-dialog]');
    const zoomImg = section.querySelector('[data-zoom-img]');
    const zoomClose = section.querySelector('[data-zoom-close]');
    const zoomPrev = section.querySelector('[data-zoom-prev]');
    const zoomNext = section.querySelector('[data-zoom-next]');
    const zoomBtn = section.querySelector('[data-zoom-btn]');
    function openZoomAt(idx) {
      if (!zoomDialog || !zoomImg) return;
      const target = mains[idx];
      if (!target) return;
      zoomImg.src = target.dataset.mediaSrc;
      zoomImg.alt = (target.querySelector('img') || {}).alt || '';
      if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
      else zoomDialog.setAttribute('open', '');
    }
    function closeZoom() {
      if (!zoomDialog) return;
      if (typeof zoomDialog.close === 'function') zoomDialog.close();
      else zoomDialog.removeAttribute('open');
    }
    mains.forEach((el, idx) => el.addEventListener('click', (e) => { e.preventDefault(); openZoomAt(idx); }));
    if (zoomBtn) zoomBtn.addEventListener('click', () => openZoomAt(currentIndex));
    if (zoomClose) zoomClose.addEventListener('click', closeZoom);
    if (zoomPrev) zoomPrev.addEventListener('click', () => { show(currentIndex - 1); openZoomAt(currentIndex); });
    if (zoomNext) zoomNext.addEventListener('click', () => { show(currentIndex + 1); openZoomAt(currentIndex); });
    if (zoomDialog) {
      zoomDialog.addEventListener('click', (e) => { if (e.target === zoomDialog) closeZoom(); });
      zoomDialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { show(currentIndex + 1); openZoomAt(currentIndex); }
        if (e.key === 'ArrowLeft') { show(currentIndex - 1); openZoomAt(currentIndex); }
      });
    }

    // Variants
    function getSelectedOptions() {
      const inputs = form.querySelectorAll('[data-option-input]:checked');
      return Array.from(inputs)
        .sort((a, b) => parseInt(a.dataset.optionPosition) - parseInt(b.dataset.optionPosition))
        .map((i) => i.value);
    }
    function findVariant(selected) {
      return variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    }
    function updateForVariant(variant) {
      const idInput = form.querySelector('[data-variant-id]');
      const priceNow = section.querySelector('[data-price-now]');
      const priceWas = section.querySelector('[data-price-was]');
      const atcBtn = section.querySelector('[data-atc-btn]');
      const atcText = section.querySelector('[data-atc-text]');
      const stickyPrice = section.querySelector('[data-sticky-price]');
      const stickyVariant = section.querySelector('[data-sticky-variant]');
      const skuEl = section.querySelector('[data-sku]');
      const stockPill = section.querySelector('[data-stock-pill]');

      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.setAttribute('aria-disabled', 'true'); }
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (stickyVariant) stickyVariant.textContent = variant.title !== 'Default Title' ? variant.title : '';
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.hidden = false;
          priceWas.textContent = money(variant.compare_at_price);
        } else { priceWas.hidden = true; }
      }
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;
      if (stockPill) {
        stockPill.classList.toggle('sv-pp__stock-pill--in', variant.available);
        stockPill.classList.toggle('sv-pp__stock-pill--out', !variant.available);
        stockPill.textContent = variant.available ? 'In stock' : 'Sold out';
      }
      if (atcBtn && atcText) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-disabled');
          atcText.innerHTML = 'ADD TO CART — ' + money(variant.price);
        } else {
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
          atcText.textContent = 'SOLD OUT';
        }
      }
      if (variant.featured_media) {
        const thumb = section.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    if (form && variants.length) {
      form.addEventListener('change', (e) => {
        if (!e.target.matches('[data-option-input]')) return;
        const selected = getSelectedOptions();
        const variant = findVariant(selected);
        const label = form.querySelector('[data-selected-value="' + e.target.dataset.optionPosition + '"]');
        if (label) label.textContent = e.target.value;
        updateForVariant(variant);
      });
    }

    // Quantity
    const qtyInput = section.querySelector('[data-qty-input]');
    const qtyDec = section.querySelector('[data-qty-dec]');
    const qtyInc = section.querySelector('[data-qty-inc]');
    if (qtyDec && qtyInput) qtyDec.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1') - 1); });
    if (qtyInc && qtyInput) qtyInc.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value || '1') + 1; });

    // ATC submit
    if (form) {
      form.addEventListener('submit', async (e) => {
        if (!window.fetch) return;
        e.preventDefault();
        const cartAddUrl = form.getAttribute('action') || ((window.routes && window.routes.cart_add_url) || '/cart/add');
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        const atcBtn = form.querySelector('[data-atc-btn]');
        const atcText = form.querySelector('[data-atc-text]');
        const originalHtml = atcText ? atcText.innerHTML : '';
        if (atcBtn) atcBtn.disabled = true;
        try {
          const fd = new FormData(form);
          const res = await fetch(cartAddUrl + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error('fail');
          if (atcBtn) atcBtn.classList.add('is-added');
          if (atcText) atcText.textContent = '✓ ADDED TO CART';
          document.dispatchEvent(new CustomEvent('sevicho:cart:added'));
          const cart = await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
          document.querySelectorAll('[data-sevicho-cart-count],.cart-count-bubble,[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
          setTimeout(() => {
            if (atcBtn) { atcBtn.classList.remove('is-added'); atcBtn.disabled = false; }
            if (atcText) atcText.innerHTML = originalHtml;
          }, 2000);
        } catch (err) { form.submit(); }
      });
    }

    // Sticky ATC
    const sticky = section.querySelector('[data-sticky]');
    const mainAtc = section.querySelector('.sv-pp__atc-row');
    if (sticky && mainAtc) {
      const obs = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { sticky.classList.remove('is-visible'); sticky.hidden = true; }
          else { sticky.hidden = false; requestAnimationFrame(() => sticky.classList.add('is-visible')); }
        });
      }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
      obs.observe(mainAtc);
      const stickyBtn = sticky.querySelector('[data-sticky-atc]');
      if (stickyBtn) stickyBtn.addEventListener('click', () => mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }

    // Copy link
    const copyBtn = section.querySelector('[data-copy-link]');
    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(copyBtn.dataset.url); } catch { /* no-op */ }
        copyBtn.classList.add('is-copied');
        setTimeout(() => copyBtn.classList.remove('is-copied'), 1500);
      });
    }

    // Shipping countdown — "order in next Xh Ym to ship today"
    const shipCountdown = section.querySelector('[data-ship-countdown]');
    const cutoffHour = parseInt(section.dataset.shippingCutoffHour || '14', 10) || 14;
    if (shipCountdown) {
      function refreshCountdown() {
        const now = new Date();
        const cutoff = new Date();
        cutoff.setHours(cutoffHour, 0, 0, 0);
        if (now >= cutoff) {
          cutoff.setDate(cutoff.getDate() + 1);
        }
        const diff = Math.max(0, Math.floor((cutoff - now) / 1000));
        const h = Math.floor(diff / 3600);
        const m = Math.floor((diff % 3600) / 60);
        const s = diff % 60;
        const label = h > 0 ? (h + 'h ' + m + 'm') : (m + 'm ' + s + 's');
        shipCountdown.textContent = label;
      }
      refreshCountdown();
      setInterval(refreshCountdown, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'sevicho:recently_viewed:v1';
    const MAX = 12;
    const root = document.querySelector('[data-sv-recently-viewed]');
    if (!root) return;
    const grid = root.querySelector('[data-sv-rv-grid]');
    const limit = parseInt(root.dataset.limit, 10) || 4;
    const currentHandle = root.dataset.currentHandle;

    function read() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; }
    }
    function write(list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX))); } catch {}
    }

    // Record current product view
    if (currentHandle) {
      const list = read().filter(h => h !== currentHandle);
      list.unshift(currentHandle);
      write(list);
    }

    // Render recently viewed (excluding current)
    const queue = read().filter(h => h !== currentHandle).slice(0, limit);
    if (queue.length === 0) return;

    Promise.all(queue.map(handle =>
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(r => r.ok ? r.json() : null)
        .catch(() => null)
    )).then(products => {
      const valid = products.filter(Boolean);
      if (valid.length === 0) return;

      const currency = root.dataset.currencyCode || 'CAD';
      const money = (cents) => (cents / 100).toLocaleString(undefined, { style: 'currency', currency });

      grid.innerHTML = valid.map(p => {
        const img = p.featured_image ? p.featured_image.replace(/(\.[^.]+)(\?.*)?$/, '_400x$1$2') : '';
        return (
          '<li><a href="' + p.url + '" class="sv-rv__card">' +
            '<div class="sv-rv__media">' +
              (img ? '<img src="' + img + '" alt="' + (p.title||'').replace(/"/g,'&quot;') + '" loading="lazy" class="sv-rv__img">' : '') +
            '</div>' +
            '<div class="sv-rv__body">' +
              '<h3 class="sv-rv__title">' + (p.title||'') + '</h3>' +
              '<p class="sv-rv__price">' + money(p.price) + '</p>' +
            '</div>' +
          '</a></li>'
        );
      }).join('');
      root.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevicho-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.querySelector('[data-sv-search-form]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    // Focus the input on page load when there is no query yet
    if (!input.value) {
      try { input.focus({ preventScroll: true }); } catch {}
    }

    // Highlight-cycle placeholder to hint at different search styles
    const placeholders = [
      'Try "mochi", "pop-it", "night-desk survival kit"',
      'Try "quiet fidget", "tiny pink something"',
      'Try "gift for a tired friend"',
      'Try "under $20", "sold out soon"'
    ];
    let idx = 0;
    const basePlaceholder = input.placeholder;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced) {
      setInterval(() => {
        if (document.activeElement === input) return;
        if (input.value) return;
        idx = (idx + 1) % placeholders.length;
        input.placeholder = placeholders[idx];
      }, 5000);
    } else {
      input.placeholder = basePlaceholder;
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
